import * as React from 'react';

import classes from './styles.module.scss';

interface State {
  currentError: any;
  errorInfo: any;
}

export class FishFail extends React.Component<React.PropsWithChildren, State> {
  static getDerivedStateFromError(currentError) {
    return { currentError };
  }

  constructor(props) {
    super(props);
    this.state = { currentError: null, errorInfo: null };
  }

  componentDidCatch(currentError, errorInfo) {
    this.setState({
      currentError,
      errorInfo,
    });
  }

  render() {
    if (!!this.state.currentError) {
      return (
        <div className={classes.container}>
          <svg width="240" height="325" viewBox="0 0 240 325" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <g fill="#F79C32">
                <path d="M111.402 259.77l.945-1.614a61.142 61.142 0 0 0 16.46 2.261c4.939 0 9.976-.614 14.986-1.788l3.257-.781.762 5.325c-2.338 20.31-50.788 36.17-52.811 36.855l-4.744 2.202 2.837-6.563c.304-.876 7.923-20.712 18.308-35.898zM68.15 183.18c-1.99 9.189-2.013 18.355-.078 27.285l-1.166.993c-14.703 12.686-39.823 22.389-40.901 22.783l-3.185 1.105 1-2.86c.172-.518 5.199-13.562 11.89-26.45 9.283-17.91 16.786-26.714 25.689-26.714 1.83 0 3.643.395 5.38 1.148l1.781.775-.41 1.935zm82.478-64.638c1.603-.74 3.212-1.419 4.965-2.141l.409-.167a128.211 128.211 0 0 1 9.76-3.449l.176-.054a161.36 161.36 0 0 1 4.6-1.308l.443-.113a131.762 131.762 0 0 1 9.406-2.095l.337-.062c1.41-.26 2.815-.482 4.308-.702l.248-.058c2.787-.394 5.684-.719 8.605-.967l.618-.048c1.245-.09 2.483-.182 3.843-.245l.189-.011c1.337-.074 2.654-.11 3.92-.138l.375-.01c.88-.01 1.731-.018 2.583-.018l1.488.008c1.066.01 2.123.03 3.14.068l.277.008c1.122.025 2.184.082 3.262.138l.768.054c.78.056 1.554.101 2.323.167l.807.072c.946.074 1.875.167 2.76.26l2.007.203.094 2.067c.044.866.077 1.789.1 2.73l.02.7c.018.94.034 1.892.023 2.97 0 1.106-.017 2.25-.05 3.36l-.01.276c-.437 14.463-3.6 36.564-16.174 59.697l-.785 1.455-1.626-.254c-38.767-6.089-51.06-43.778-54.542-59.7l-.415-1.9 1.748-.793zm-33.626 22.69l.742-.674c1.095-1.004 2.19-2 3.29-2.942l.536-.47a138.93 138.93 0 0 1 3.738-3.072l.139-.11a158.315 158.315 0 0 1 3.637-2.767l3.19-1.881.792 2.913c11.396 41.658 37.71 57.447 52.447 63.155 5.413 2.245 16.123 4.63 28.885 6.43 25.917-39.829 26.203-79.197 24.036-99.239l-.105-.968s-.077-2.785-2.438-5.59c-3.373-4.004-7.216-4.198-7.216-4.198-5.58-.912-14.509-2-25.263-2-28.67 0-70.257 7.58-105.613 43.646-9.13 9.307-16.362 18.817-21.499 28.266l-1.04 1.913-1.967-.904c-3.246-1.483-6.53-2.245-9.749-2.245-19.536 0-36.024 27.559-46.414 50.673C8.355 230.678 2.366 250.416 0 258.779c11.756-3.749 46.53-15.68 70.75-32.452l2.16-1.5 1.234 2.352c5.27 10.114 11.457 15.975 11.6 16.115.04.035 4.02 4.113 11.043 8.245l2.107 1.23-1.278 2.103c-14.847 24.268-26.984 58.56-30.44 69.798 8.682-2.553 37.225-12.546 57.452-22.397 23.528-11.44 44.777-21.695 39.983-49.979l-.404-1.745 2.207-1.255.337-.13c18.524-10.416 33.88-23.785 39.514-28.943-11.186.387-43.71-8.07-55.113-12.667 1.71 1.552 18.994 15.414 18.994 15.414l-2.327 1.754c-12.834 9.64-25.458 14.553-37.523 14.553-11.048 0-19.332-4.131-24.336-7.614 0 0-.724-.5-.978-.702 0 0-.752-.562-1.084-.833 0 0-.635-.499-.752-.615-.149-.104-.685-.57-.962-.807l-.531-.499c-.232-.194-.432-.394-.652-.606l-.006-.017h-.05l-.686-.71c-7.85-8.107-30.168-37.947 12.856-81.84a155.56 155.56 0 0 1 3.887-3.8z" />
                <path d="M202.66 120.153c-2.802 4.511-6.1 7.949-9.892 10.31-1.967 1.226-3.942 2.17-5.925 2.837-2.335.78-5.038 1.365-8.109 1.755l1.413 2.362c-.007 0 4.679 7.88 4.679 7.88 3.008.288 5.668.191 7.978-.29 2.31-.479 4.515-1.373 6.614-2.68a20.44 20.44 0 0 0 5.211-4.615c1.45-1.814 2.823-4.254 4.122-7.317l-6.091-10.242z" />
              </g>
            </g>
          </svg>
          <h1>There was an unexpected error...</h1>
          <h2>If this keeps happening, let Ted know.</h2>
          <br />
          <br />
          <br />
          <h2>Technical Stuff:</h2>
          <p>{this.state.currentError && this.state.currentError.toString()}</p>
          <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
        </div>
      );
    }

    return this.props.children;
  }
}
